var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeGolden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2334 15.2917L8.81673 17.2917C9.15006 17.625 9.90006 17.7917 10.4001 17.7917H13.5667C14.5667 17.7917 15.6501 17.0417 15.9001 16.0417L17.9001 9.95835C18.3167 8.79168 17.5667 7.79168 16.3167 7.79168H12.9834C12.4834 7.79168 12.0667 7.37501 12.1501 6.79168L12.5667 4.12501C12.7334 3.37501 12.2334 2.54168 11.4834 2.29168C10.8167 2.04168 9.9834 2.37501 9.65006 2.87501L6.2334 7.95835",
    stroke: "#F6B21A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9834 15.2917V7.12502C1.9834 5.95835 2.4834 5.54169 3.65007 5.54169H4.4834C5.65006 5.54169 6.15007 5.95835 6.15007 7.12502V15.2917C6.15007 16.4584 5.65006 16.875 4.4834 16.875H3.65007C2.4834 16.875 1.9834 16.4584 1.9834 15.2917Z",
    stroke: "#F6B21A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeGolden);
export default __webpack_public_path__ + "static/media/like-golden.ddfed9e5bcda573d90b11c91cefd6b10.svg";
export { ForwardRef as ReactComponent };